import React from "react";
import Typewriter from "typewriter-effect";
function Type() {
  return <Typewriter options={{ strings: ["Senior Full Stack Developer", "React.js & TypeScript", "Node.js & Express.js", "Java Spring Boot", "Micro-Frontend Developer"], autoStart: true, loop: true, deleteSpeed: 50 }} />;
}
export default Type;
